import isNil from 'lodash/isNil';
import { any, func, number, string } from 'prop-types';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { Button } from 'reactstrap';

import { COLORS } from '../utils/constants';
import { tapFlashError, tapFlashSuccess } from '../utils/flash';
import isPermitted from '../utils/is-permitted';
import RequestComponent from './RequestComponent';

class DeleteButton extends RequestComponent {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    event.preventDefault();
    if (!this.isLoading()) {
      const { onDelete, name, id } = this.props;
      // eslint-disable-next-line no-alert
      if (window.confirm(this.getConfirmationMessage())) {
        this.trackRequest(onDelete({ id })).then(
          tapFlashSuccess(`Deleted ${name}`),
          tapFlashError(),
        );
      }
    }
  }

  getConfirmationMessage() {
    const { name, confirmationMessage } = this.props;
    return confirmationMessage || `Do you really want to delete ${name}?`;
  }

  render() {
    const { result } = this.state;
    const { onDelete, redirectTo, name, confirmationMessage, ...rest } =
      this.props;

    if (!isNil(result)) {
      return <Redirect push to={redirectTo} />;
    }

    return (
      <Button
        color={COLORS.DANGER}
        onClick={this.handleClick}
        disabled={!isPermitted(onDelete)}
        {...rest}
      >
        Delete
      </Button>
    );
  }
}

DeleteButton.propTypes = {
  onDelete: func.isRequired,
  id: number.isRequired,
  redirectTo: any.isRequired, // eslint-disable-line react/forbid-prop-types
  name: string,
  confirmationMessage: string,
};

DeleteButton.defaultProps = {
  name: 'this business object',
  confirmationMessage: '',
};

export default DeleteButton;
